import { render } from "./PromoCodeList.vue?vue&type=template&id=4d5afe66&scoped=true"
import script from "./PromoCodeList.vue?vue&type=script&lang=js"
export * from "./PromoCodeList.vue?vue&type=script&lang=js"

import "./PromoCodeList.vue?vue&type=style&index=0&id=4d5afe66&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5afe66"]])

export default __exports__